// extracted by mini-css-extract-plugin
module.exports = {"listing":"CountryItem_listing__1ZNV9","number":"CountryItem_number__2zocP"};